'use strict';

import { render, unmountComponentAtNode } from 'react-dom';
import PjaxWrapper from '../../utils/PjaxWrapper';
import EnumVXButton from '../../components/SimpleElements/VXButton/EnumVXButton';
import VXButton from '../../components/SimpleElements/VXButton/VXButton';
import VXButtonOutline from '../../components/SimpleElements/VXButton/Presets/VXButtonOutline';
import { VXButtonLineConfig } from '../../components/SimpleElements/VXButton/VXButtonConfig';

/**
 * @param containerId
 * @param buttonConfig
 */
function run(containerId, buttonConfig) {
	const {
		line1 = '',
		color = '',
		link = '',
		icon = null,
		preset = EnumVXButton.PRESET.DEFAULT,
		line2 = '',
		disabled = false,
		animateSuccess = false,
	} = buttonConfig;

	const container = document.getElementById(containerId);

	const config = {
		color: color,
		border: EnumVXButton.BORDER.NONE,
		link: link,
		line1: [new VXButtonLineConfig(line1)],
		icon,
		disabled,
		animateSuccess,
	};

	if (line2) {
		config.line2 = [new VXButtonLineConfig(line2)];
	}

	let content;

	switch (preset) {
		case EnumVXButton.PRESET.OUTLINE:
			content = <VXButtonOutline {...config} />;
			break;

		case EnumVXButton.PRESET.DEFAULT:
			content = <VXButton {...config} />;
			break;

		default:
			content = <VXButton {...config} />;
	}

	if (container) {
		render(content, container);

		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(container);
		});
	}
}

export { run };
